import { useEffect, useState } from "react";
import { Menu, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { NAV, STUDIO } from "@/content";
import { SITE } from "@/constants/testIds";

const Brand = () => (
  <a href="#top" data-testid={SITE.headerLogo} className="flex items-center gap-3 group">
    <img src="/brand/monogram-navy.png" alt="Monogramma D'Arienzo" className="h-10 w-10 object-contain" />
    <span className="leading-none">
      <span className="block text-[15px] font-medium tracking-[0.22em] text-navy-900">D'ARIENZO</span>
      <span className="block mt-1 text-[9px] font-bold tracking-[0.42em] text-navy-900/80">STUDIO LEGALE</span>
    </span>
  </a>
);

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 12);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <header
      data-testid={SITE.header}
      className={`fixed top-0 inset-x-0 z-50 bg-white transition-shadow duration-300 ${scrolled ? "shadow-[0_6px_24px_rgba(0,43,74,0.08)]" : ""}`}
    >
      <div className="container-x flex h-20 items-center justify-between gap-6">
        <Brand />
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              data-testid={SITE.navLink(n.id)}
              className="relative text-[13px] font-medium text-navy-900/80 hover:text-navy-900 transition-colors after:absolute after:left-0 after:-bottom-1.5 after:h-px after:w-full after:origin-left after:scale-x-0 after:bg-bronze after:transition-transform hover:after:scale-x-100"
            >
              {n.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a
            href={STUDIO.phoneHref}
            className="hidden md:inline-flex items-center gap-2 px-3 text-[13px] font-semibold text-navy-900 hover:text-bronze-600 transition-colors"
          >
            <Phone className="h-4 w-4" /> {STUDIO.phoneLabel}
          </a>
          <Button asChild data-testid={SITE.headerBookBtn} className="hidden sm:inline-flex rounded-full bg-navy-900 hover:bg-navy-700 h-11 px-5 text-[13px] font-semibold tracking-wide transition-colors">
            <a href="#prenota">Prenota</a>
          </Button>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" data-testid={SITE.mobileMenuBtn} className="lg:hidden text-navy-900" aria-label="Apri menu">
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-white w-[85vw] max-w-sm">
              <SheetTitle className="sr-only">Menu</SheetTitle>
              <img src="/brand/logo-navy.png" alt="Studio Legale D'Arienzo" className="h-20 w-auto mt-4 mb-10" />
              <nav className="flex flex-col">
                {NAV.map((n) => (
                  <a
                    key={n.id}
                    href={`#${n.id}`}
                    onClick={() => setOpen(false)}
                    data-testid={SITE.mobileNavLink(n.id)}
                    className="py-4 border-b border-navy-100 text-lg font-medium text-navy-900 hover:text-bronze-600 transition-colors"
                  >
                    {n.label}
                  </a>
                ))}
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
